import { Link } from 'react-router-dom';
import PageMeta from '../../components/SEO/PageMeta';
import { FORMAT_LABELS, getAllConversionRoutes } from '../../config/conversions';
import { SITE_NAME } from '../../config/site';
import { IMAGE_FORMATS } from '../../types/media';
import styles from './ImageConvertersPage.module.css';

const routes = getAllConversionRoutes();

export default function ImageConvertersPage() {
  return (
    <>
      <PageMeta
        title="Free Online Image Converters"
        description={`Browse all ${SITE_NAME} image conversion tools for JPEG, PNG, WebP, SVG, GIF, BMP, TIFF, and ICO files.`}
        path="/image-converters"
      />

      <section className={styles.hero}>
        <p className={styles.eyebrow}>Media converter</p>
        <h1>All image converters</h1>
        <p>
          Choose any supported image conversion route. Convert between JPEG, PNG, WebP, SVG, GIF,
          BMP, TIFF, and ICO formats from dedicated tool pages.
        </p>
      </section>

      <section className={styles.formats} aria-labelledby="formats-heading">
        <h2 id="formats-heading">Supported formats</h2>
        <ul className={styles.formatList}>
          {IMAGE_FORMATS.map((format) => (
            <li key={format}>
              <span className={styles.formatChip}>{FORMAT_LABELS[format]}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className={styles.gridSection} aria-labelledby="converters-heading">
        <div className={styles.sectionHeader}>
          <h2 id="converters-heading">Available converters ({routes.length})</h2>
          <p>Every route opens a focused converter page for that exact format pair.</p>
        </div>
        <div className={styles.grid}>
          {routes.map(({ slug, from, to }) => (
            <Link key={slug} to={`/media/${slug}`} className={styles.card}>
              <span className={styles.cardFrom}>{FORMAT_LABELS[from]}</span>
              <span className={styles.cardArrow} aria-hidden>
                →
              </span>
              <span className={styles.cardTo}>{FORMAT_LABELS[to]}</span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
